interface BottomUpScrollTranslateValueParams {
  currentScrollPosition: number; // current scroll position
  threshold?: number; //  scroll threshold at or after which element's animation should start.
}

/**
 * Return percentage value used to animate an element meaning scroll up animation.
 * */
const bottomUpScrollTranslateValue = ({
  currentScrollPosition,
  threshold
}: BottomUpScrollTranslateValueParams) => {
  const scrollingThreshold = threshold ?? 200;
  const maxValue = 100;
  const minValue = 0;

  if (currentScrollPosition < scrollingThreshold) {
    return maxValue;
  }

  const scrollDifference = Math.floor(
    currentScrollPosition - scrollingThreshold
  );
  const translateY = maxValue - scrollDifference;
  const percentage = translateY > minValue ? translateY : minValue;

  return percentage;
};

export default bottomUpScrollTranslateValue;
